import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from "mobx";
import Accordion from "@components/Accordion/Accordion";
import classnames from "classnames";

@inject("store")
@observer
export default class BerikssonCategoryNavigationSticky extends React.Component {

    constructor(props) {
        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);

        this.handleFacetChanged = this.handleFacetChanged.bind(this);
        this.handleOpened = this.handleOpened.bind(this);
        this.accordionCallback = this.accordionCallback.bind(this);
        this.navigateToCategory = this.navigateToCategory.bind(this);

        this.state = {
            openedAccordions: this.props.store.navigation.facets
                .filter(f => f.IsOpen || f.FacetValues.filter(x => x.Selected).length > 0)
                .map(x => ({Name: x.Name, Index: 0}))// [{name:"facet1", index:0}]
        }
    }

    componentDidMount() {
        if (this.props.onLoad) {
            this.props.onLoad();
        }
    }

    navigateToSiteUrl(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.navigateToSiteUrl(navigation.mainTree, node.Url, node.Name);
    }

    navigateToCategory(e, url, withFacets = true) {
        console.debug("navigateToCategory, url", url, withFacets);
        if (e) {
            e.preventDefault();
        }
        const navigation = this.props.store.navigation;

        if (withFacets) {
            navigation.updateLocationFromFacets(url);
        } else {
            navigation.updateLocationWithoutFacets(url);
        }

    }

    handleFacetChanged(facetName, facetOptionValue) {
        const navigation = this.props.store.navigation;
        this.handleOpened(facetName);
        navigation.toggleFacetOption(facetName, facetOptionValue);
        //window.scrollTo(0, 0);
    }


    handleOpened(facetName) {
        var facet1 = this.state.openedAccordions.length > 0 ? this.state.openedAccordions.find((f) => {
            return f === facetName
        }) : null;

        if (!facet1) {
            this.state.openedAccordions.push(facetName);
        }
    }

    accordionCallback(accordionName, openIndex) {

        const accordionIndex = this.state.openedAccordions.length > 0 ? this.state.openedAccordions.findIndex(x => x.Name === accordionName) : -1;

        //console.log("facet1", facetName, facet1, state, this.state.openedAccordions)

        if (accordionIndex === -1 && openIndex > -1) {

            this.setState({openedFacets: [...this.state.openedAccordions, {Name: accordionName, Index: openIndex}]}, () => {
                //console.log("accordionCallback after Add: ", accordionName, openIndex, this.state.openedAccordions);
            })

        } else if (accordionIndex > -1 && openIndex === false) {
            const openedFacets = [...this.state.openedAccordions];
            openedFacets.splice(accordionIndex, 1);
            //console.log("accordionCallback - remove", facet1, openedFacets);

            this.setState({openedFacets: openedFacets}, () => {
                //console.log("accordionCallback after Add: ", facetName, state, this.state.openedAccordions);
            })
        }


        if (this.props.callback) {
            this.props.callback();
        }
    }

    renderCategoryCount(category, categoryIdsFacet) {
        const navigation = this.props.store.navigation;
        const categoryId = category.CategoryIds[0];
        if (!categoryIdsFacet) return null;

        const facetValue = categoryIdsFacet.FacetValues.find(x => x.Value === categoryId);
        if (!facetValue) {
            return (<span style={{color: "#aaa"}}>(0)</span>);
        }

        //console.log("categoryIdsFacet", categoryIdsFacet, facetValue);
        return (<span style={{color: "#aaa"}}>({facetValue.Hits})</span>

        );

    }

    renderBreadCrumbs(breadCrumbs) {
        const navigation = this.props.store.navigation;
        const mainTree = navigation.mainTree;

        return (
            breadCrumbs && breadCrumbs.FacetValues && breadCrumbs.FacetValues.length > 0 && <div key={'bread-crumbs'} className="facet-group">
                <a href=""
                   onClick={(e) => this.navigateToCategory(e, mainTree.SearchUrl, false)}>
                    <strong>Alla produkter</strong></a>
                {/*<ul className="facet-rows">*/}
                {/*    {breadCrumbs.FacetValues.map((category, index) => {*/}
                {/*        //const isActive = navigation.NodeIsActive(category.Id);*/}
                {/*        //console.log("isActive:", category.Id, isActive, category.Name);*/}
                {/*        ///const isActive = currentUrl.startsWith(category.Url);*/}
                {/*        //console.log("category.Guid", category.Guid);*/}
                {/*        return (<li key={category.Guid}>*/}
                {/*            <a href={category.UrlSlug}*/}
                {/*               onClick={(e) => this.navigateToCategory(e, category.UrlSlug, category.Value)}>*/}
                {/*                {index < (breadCrumbs.FacetValues.length - 1) && "< "}*/}
                {/*                {category.Value}</a>*/}
                {/*            /!*{category.Count}*!/*/}
                {/*        </li>);*/}
                {/*    })}*/}
                {/*</ul>*/}
            </div>);
    }

    renderCategoriesFacet(subCategoriesFacet) {
        return (<div key={'categories'} className="facet-categories">
            {this.renderLevelByParent(subCategoriesFacet)}
        </div>);

    }


    renderCategoryNodes(umbNode) {
        return (<div
            // key={'umbNodes-' + this.props.store.navigation.CurrentUrl}
            key={'umbNodes'}
            className="facet-categories">
            {this.renderNodeLevelByParent(umbNode)}
        </div>);

    }

    findCategoryNode(currentNode, url) {
        if (!currentNode || !currentNode.Children || currentNode.Children.length === 0) {
            return null
        }
        const bestMatch = currentNode.Children.find(x => x.Url.startsWith(url));

        if (bestMatch && bestMatch.Url === url) {
            return bestMatch;
        } else {
            return this.findCategoryNode(bestMatch);
        }
    }


    renderLevel(subCategoryFacetsValues) {
        const navigation = this.props.store.navigation;
        const currentUrl = navigation.CurrentUrl;

        return (subCategoryFacetsValues && subCategoryFacetsValues.length > 0 && <ul className="facet-rows">
            {subCategoryFacetsValues.map(category => {

                //const isActive = navigation.NodeIsActive(category.Id);

                //console.log("isActive:", category.Id, isActive, category.Name);


                const isActive = currentUrl.startsWith(category.Url);
                return (<li key={category.Guid} className={isActive ? "active" : ""}>
                    <div key="1" className="category-title"><a href={category.UrlSlug}
                                                               onClick={(e) => this.navigateToCategory(e, category.UrlSlug)}>
                        {category.Value}</a>
                    </div>
                    <div key="2" className="facet-hits">({category.Count})</div>


                </li>);
            })}
        </ul>);
    }


    renderLevelByParent(categoryLevel) {
        const navigation = this.props.store.navigation;
        const currentUrl = navigation.CurrentUrl;

        let selectedIndex = categoryLevel.FacetValues.findIndex(x => x.Selected);

        return (
            <Accordion className='category-group'
                       transitionDuration={150}
                       key={categoryLevel.Guid || "categories"}
                       name={categoryLevel.Guid}
                       displayName={categoryLevel.Value}
                       selectedIndex={selectedIndex}//{(opened) ? 0 : -1}
                       callback={this.accordionCallback}
            >

                {categoryLevel.FacetValues && categoryLevel.FacetValues.length > 0 && categoryLevel.FacetValues
                    .map(category => {
                        const hasDivider = category.PropertyByKey("Divider") || false;
                        return (
                            category.FacetValues && category.FacetValues.length > 0
                                ? <div key={category.Guid} data-header={category.Value}
                                    // data-subheader={category.Count > 0 ? "(" + category.Count + ")" : ""} 
                                       data-headerclass={"category-header has-children  " + (category.Selected ? "active " : " ")}
                                       data-wrapperclass={(hasDivider ? "divider" : "")}
                                       data-ontitleopenclick={(e) => this.navigateToCategory(e, category.UrlSlug)}>
                                    {this.renderLevelByParent(category)}
                                </div>
                                :
                                <div key={category.Guid}>
                                    <div className={"category-header " + (category.Selected ? "active " : " ") + (hasDivider ? " divider" : "")}>
                                        <a href={category.UrlSlug} onClick={(e) => this.navigateToCategory(e, category.UrlSlug, category.Count > 0)}>
                                            {category.Value}
                                            {/*{category.Count > 0 && <span>({category.Count})</span>}*/}
                                        </a>
                                    </div>
                                </div>


                        );
                    })}

            </Accordion>
        );

    }


    renderNodeLevelByParent(umbNode) {
        const navigation = this.props.store.navigation;
        const currentUrl = navigation.CurrentUrl;

        const children = umbNode.Children.filter(f => f.Alias === "icom_filter" && !(f.PropertyByKey("hideInCategory") != null && f.PropertyByKey("hideInCategory")));
        let selectedIndex = children.findIndex(x => currentUrl.indexOf(x.Url) > -1);
        return (
            <Accordion className='category-group'
                       transitionDuration={90}
                       key={umbNode.Id || "categories"}
                       name={umbNode.Id}
                       displayName={umbNode.Name}
                       selectedIndex={selectedIndex}//{(opened) ? 0 : -1}
                //callback={this.accordionCallback}
            >

                {children && children.length > 0 && children.map(childNode => {
                        const hasDivider = childNode.PropertyByKey("hasDivider") || false;
                        const isActive = currentUrl.indexOf(childNode.Url) > -1;
                        const childNodes = childNode.Children.filter(f => f.Alias === "icom_filter" && !(f.PropertyByKey("hideInCategory") != null && f.PropertyByKey("hideInCategory")));
                        const hasChildren = childNodes.length > 0;
                        return (
                            <div key={childNode.Id} data-header={childNode.Name}
                                // data-subheader={category.Count > 0 ? "(" + category.Count + ")" : ""} 
                                 data-headerclass={"category-header " + (hasChildren ? "has-children" : "") + " " + (isActive ? "active " : " ")}
                                 data-wrapperclass={(hasDivider ? "divider" : "")}
                                 data-ontitleopenclick={(e) => this.navigateToCategory(e, childNode.Url, false)}>
                                {this.renderNodeLevelByParent(childNode)}
                            </div>
                        );
                    })}

            </Accordion>
        );
    }

    render() {
        // const categoryClasses = classnames(
        //     "facet-rows");
        //
        // const subCategories = this.props.showCategories && this.props.store.navigation.facets.find(x => x.Name === "SubCategories");
        return [
            //this.renderBreadCrumbs(breadCrumbs),
            //icomsubCategories && this.renderCategoriesFacet(subCategories),

            this.props.showCategories ? this.renderCategoryNodes(this.props.store.navigation.mainTree) : null,

            this.props.store.navigation.facets.map(facet => {

                if (facet.Name === "SubCategories" || facet.Name === "BreadCrumbs") {
                    return null;
                }


                //if (!this.props.store.navigation.isMobile) {
                //    return;
                //}
                let opened = facet.FacetValues.filter(x => x.Selected).length > 0;

                if (facet.IsOpen || this.state.openedAccordions.length > 0 &&
                    this.state.openedAccordions.find((f) => {
                        return f.Name === facet.Name
                    })) {
                    opened = true;
                }


                const showColors = facet.FacetValues.filter(x => x.ColorCode).length > 0;
                const isBooleanFacet = facet.FacetValues.filter(x => x.IsBooleanValue).length > 0;

                const facetOptions = facet.FacetValues.filter(x => x.Count > 0 || x.Selected).map(facetValue => ({
                    value: facetValue.Value,
                    label: facetValue.Value,
                    count: facetValue.Count,
                    selected: facetValue.Selected,
                    colorcode: facetValue.ColorCode
                }));

                const classes = classnames(
                    "facet-rows",
                    showColors ? "color-picker" : null,
                    facet.IsSizeFacet ? "size-picker" : null,
                    isBooleanFacet ? "no-header" : null
                );

                let displayName = facet.DisplayName;
                if (facet.DisplayName.indexOf("_") > -1) {
                    let i = facet.DisplayName.indexOf("_");
                    displayName = facet.DisplayName.substring(0, i);
                }


                return (
                    <React.Fragment key={facet.Name}>
                        {!isBooleanFacet &&
                            <Accordion className='facet-group'
                                       transitionDuration={150}
                                       key={facet.Name}
                                       name={facet.Name}
                                       selectedIndex={(opened) ? 0 : -1}
                                       callback={this.accordionCallback}
                            >
                                <div data-header={displayName} data-headerclass="facet-header">
                                    <ul className={classes}>
                                        {facetOptions.map(facetOption => {
                                            var classNames = [facetOption.selected ? "selected" : null, facetOption.count === 0 ? "greyed" : null
                                            ];


                                            const styles = {
                                                background: facetOption.colorcode ? (facetOption.colorcode === "gradient" ? "url(/dist/img/gradient_wheel.png)" : "#" + facetOption.colorcode) : null,
                                                border: facetOption.colorcode === "ffffff" ? "1px solid #ccc" : null
                                            }
                                            return (
                                                <li key={facet.Name + "-" + facetOption.value}
                                                    className={classNames.join(' ')}
                                                    onClick={(e) => {
                                                        this.handleFacetChanged(facet.Name, facetOption.value);
                                                    }}
                                                >
                                                    <input type="checkbox"/>
                                                    <label
                                                        style={styles}>
                                                        {!showColors && <div className="facet-title">{facetOption.label}</div>} {!showColors && !facet.IsSizeFacet && <div className="facet-hits">({facetOption.count})</div>}</label>
                                                    {showColors && <span style={{display: "block"}}>{facetOption.label}</span>}
                                                </li>);


                                        })}

                                    </ul>
                                </div>
                            </Accordion>}
                        {isBooleanFacet && <div className="facet-group" key={facet.Name}>
                            <ul className={classes}>
                                {facetOptions.map(facetOption => {
                                    var classNames = [facetOption.selected ? "selected" : null, facetOption.count === 0 ? "greyed" : null
                                    ];

                                    return (
                                        <li key={facet.Name + "-" + facetOption.value}
                                            className={classNames.join(' ')}
                                            onClick={(e) => {
                                                this.handleFacetChanged(facet.Name, facetOption.value);
                                            }}
                                        >
                                            <input type="checkbox"/>
                                            <label>
                                                <span>{facet.Name}</span> <span style={{color: "#aaa"}}>({facetOption.count})</span></label>
                                        </li>);
                                })}

                            </ul>
                        </div>}
                    </React.Fragment>
                );

            })
        ];
    }
}


